import React, { useEffect, useRef, useState } from "react";
import { Sidebar } from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import back from "../../assets/svg/backArrow.svg";
import uploadImage from "../../assets/svg/uploadImage.svg";
import "../common/Util.css";
import "./CreateProduct.css";
import { X } from "lucide-react";
import CommonDropdown from "../common/common_dropDown";
import Dropdown from "react-bootstrap/Dropdown";
import dropDown from "../../assets/svg/dropDown.svg";
import AsyncSelect from "react-select/async";
import axios from "axios";
import { getCookie } from "../../getcookie";
import { apiCall } from "../../services/api-service";
import CommonStaticDropdown from "../common/common_static_dropdown";
import ErrorExtractor from "../common/error_extractor";
import DOMPurify from "dompurify";
import {
  getProductEditApi,
  saveAttachmentApi,
  submitProductAPI,
  updateProductAPI,
} from "./productApi";
import { useLocation, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { MoveLeft } from "lucide-react";
export const CreateProduct = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const from = location.state?.from;
  const vendorFromNav = location.state || null;
  const { id } = location.state || {};
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;
  // file input
  const fileInputRef = useRef(null);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [uomOption, setUomOption] = useState(null);
  const [partFamilyOption, setPartFamilyOption] = useState(null);
  const [orginOption, setOrginOption] = useState(null);
  const [statusOption, setStatusOption] = useState({
    value: true,
    label: "Active",
  });
  const [isLoader, setIsLoader] = useState(false);
  const [lengthValue, setLengthValue] = useState("");
  const [productValue, setProductValue] = useState("");
  const [codeValue, setCodeValue] = useState("");
  const [breadthValue, setBreadthValue] = useState("");
  const [heightValue, setHeightValue] = useState("");
  const [descriptValue, setDescriptValue] = useState("");
  const [selectedUnit, setSelectedUnit] = useState({
    label: "CM",
    value: "cm",
  });
  const handleBack = () => {
    if (from === "vendor") {
      navigate("/viewVendor", {
        state: {
          activeTab: "product",
          id: location.state?.vendorId,
        },
      });
    } else {
      navigate("/product");
    }
  };

  useEffect(() => {
    console.log("vendorFromNav", vendorFromNav);
    if (vendorFromNav && vendorFromNav.vendorId && vendorFromNav.vendorName) {
      setSelectedSupplierList([
        { value: vendorFromNav.vendorId, label: vendorFromNav.vendorName },
      ]);
    }
  }, [vendorFromNav]);

  const [errorMsg, setErrorMsg] = useState({
    code: "",
    name: "",
    uom: "",
    product_group_id: "",
    origin: "",
    lead_time: "",
    inspection_type: "",
    min_qty: "",
    width: "",
    length: "",
    height: "",
    dimension: "",
    status: "",
    description: "",
    suppliers: "",
    removed_suppliers: "",
  });
  const selectUnitOption = [
    { label: "CM", value: "cm" },
    { label: "Inch", value: "inch" },
    { label: "M", value: "m" },
    { label: "MM", value: "mm" },
  ];
  const [selectedSupplierList, setSelectedSupplierList] = useState([]);
  const [removeSupplierList, setRemoveSupplierList] = useState([]);
  const [imageRemoved, setImageRemoved] = useState(false);

  const [dragging, setDragging] = useState(false);

  const handleInputFile = () => {
    fileInputRef.current.click();
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      /* const imageUrl = URL.createObjectURL(file);
        setImage(imageUrl); */
      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = await reader.result;
        setImage(base64String);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleAutoSupplierDropdownChange = (selectedOptions) => {
    // Find removed options
    const removed = selectedSupplierList.filter(
      (oldItem) =>
        !selectedOptions?.some((newItem) => newItem.value === oldItem.value),
    );

    if (removed.length > 0) {
      setRemoveSupplierList((prev) => [...prev, ...removed]);
    }

    setSelectedSupplierList(selectedOptions);
  };
  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);

    const file = event.dataTransfer.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = await reader.result;
        setImage(base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  const multiselectCustomStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      border: "0.7px solid #E5E5E5",
      padding: "2px",
      fontWeight: "500",
      fontSize: "13px",
      color: "#212129",
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#007bff"
        : state.isFocused
          ? "#e0e0e0"
          : "#fff",
      color: state.isSelected ? "#fff" : "#333",
      padding: 10,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#F6F7F8",
      color: "#212129",
      borderRadius: "5px",
      padding: "2px 5px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#212129",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#212129",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };

  useEffect(() => {
    if (id != null) {
      getProductEdit(id);
    }
  }, [id]);
  //API

  const submitForm = async () => {
    setIsLoader(true);
    const extractor = new ErrorExtractor();
    try {
      const preSanitizeData = {
        code: codeValue,
        name: productValue,
        uom: uomOption?.value ?? "",
        product_group_id: partFamilyOption?.value ?? "",
        origin: orginOption?.value ?? "",

        width: breadthValue,
        length: lengthValue,
        height: heightValue,
        dimension: selectedUnit?.value ?? "",
        status: statusOption?.value ?? "",
        suppliers: selectedSupplierList
          .filter((item) => item.value !== "")
          .map((item) => item.value),
        removed_suppliers: removeSupplierList
          .filter((item) => item.value !== "")
          .map((item) => item.value),
        description: descriptValue,
      };
      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (
          typeof value === "boolean" ||
          typeof value === "number" ||
          Array.isArray(value) ||
          key === "assignee"
        ) {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });
      var response = null;
      if (id == null) {
        response = await submitProductAPI(sanitizedData);
      } else {
        response = await updateProductAPI(id, sanitizedData);
      }

      console.log("sdddd", response);
      // Check if response indicates failure
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            code: "",
            name: "",
            uom: "",
            product_group_id: "",
            origin: "",
            lead_time: "",
            inspection_type: "",
            min_qty: "",
            width: "",
            length: "",
            height: "",
            dimension: "",
            status: "",
            description: "",
            suppliers: "",
            removed_suppliers: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      } else if (response.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        console.log("saveAttachment called 0");
        console.log("image", image);
        console.log("imageRemoved", imageRemoved);
        if (image === null && imageRemoved == false) {
          console.log("saveAttachment called 1");
          handleBack();
        } else {
          console.log("saveAttachment called 2");
          saveAttachment(response.data.id);
        }
      }
    } catch (err) {
      console.error("Error submitting form:", err);

      // Optional: handle network errors separately
      if (
        err.response &&
        err.response.status === 400 &&
        err.response.data.error
      ) {
        const errorvalue = extractor.extractErrors(err.response.data, {
          ...errorMsg,
        });
        setErrorMsg(errorvalue);
      }
    } finally {
      setIsLoader(false);
    }
  };
  const getProductEdit = async (id) => {
    try {
      const response = await getProductEditApi(id);

      if (response.data.success === true) {
        const productDetail = response.data.product ?? {};
        setPartFamilyOption({
          label: productDetail.product_group_label ?? "",
          value: productDetail.product_group_value ?? "",
        });
        setUomOption({
          label: productDetail.uom_label ?? "",
          value: productDetail.uom_value ?? "",
        });
        setStatusOption({
          label: productDetail.status === true ? "Active" : "In-Active",
          value: productDetail.status ?? false,
        });
        setOrginOption({
          label: productDetail.origin_label ?? "",
          value: productDetail.origin_value ?? "",
        });

        setDescriptValue(productDetail.description ?? "");
        setProductValue(productDetail.name ?? "");
        setCodeValue(productDetail.code ?? "");
        setHeightValue(productDetail.height ?? "");
        setBreadthValue(productDetail.width ?? "");
        setLengthValue(productDetail.length ?? "");
        setSelectedSupplierList(productDetail.suppliers ?? []);
        setSelectedUnit({
          label: (productDetail.dimension ?? "").toUpperCase(),
          value: productDetail.dimension ?? "",
        });
        setImageUrl(productDetail.image ?? "");
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const saveAttachment = async (parentId) => {
    console.log("saveAttachment called");
    try {
      const data = {
        attachment: image != null ? image : imageRemoved === true ? "" : "",
      };
      const response = await saveAttachmentApi(parentId, data);
      if (response.data.success === true) {
        handleBack();
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  };

  const fetchOptionsAutoSupplier = (inputValue, callback) => {
    apiCall("get", `get_vendor?&term=${inputValue || ""}`)
      .then((response) => {
        const options = response.data.suggestionlist.map((item) => ({
          value: String(item.value),
          label: String(item.label),
        }));
        callback(options); // ✅ Must call callback to update AsyncSelect
      })
      .catch((error) => {
        console.error("API Error:", error);
        callback([]); // return empty on error
      });
  };
  return (
    <>
      <div className="d-flex">
        {/* Sidebar */}
        <Sidebar currentfile="Products" />
        {/* Main Content */}
        <div className="rounded-4 flex-grow-1">
          <div className="" style={{ backgroundColor: "#F5F8FA" }}>
            <Navbar pageTitle="Products" />
            <div
              className="d-flex bg-white align-items-center justify-content-between p-3"
              style={{ height: "64px" }}
            >
              <div className="d-flex align-items-center gap-3">
                <MoveLeft
                  className="cursor-pointer"
                  onClick={() => {
                    handleBack();
                  }}
                />
                <p className="m-0 fs-16 fw-600">
                  {id != null ? "Update product" : "New product"}
                </p>
              </div>
              <div className="d-flex gap-3">
                <button
                  onClick={() => {
                    handleBack();
                  }}
                  className="rounded-pill px-4 py-1 bg-transparent fs-15 fw-500 textcolor"
                  style={{ border: "1px solid #D4DDE7", height: "40px" }}
                >
                  Cancel
                </button>
                <button
                  className="backgroundPrimary rounded-pill px-4 py-1 text-white border-0 fs-15 fw-500 "
                  onClick={
                    isLoader
                      ? null
                      : () => {
                          submitForm();
                        }
                  }
                  style={{ height: "40px" }}
                >
                  {isLoader ? (
                    <Spinner animation="border" size="sm" />
                  ) : id != null ? (
                    "Update"
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </div>
            <div className="p-3">
              <div className="bg-white rounded-4 p-3">
                <div className="d-flex justify-content-between">
                  <div className="d-flex flex-column w-75">
                    <p className="fs-16 fw-600">Product details</p>
                    <p className="fs-14 fw-600 d-flex textltcolor mb-1">
                      Product Name<span className="error-text">*</span>
                    </p>
                    <input
                      type="text"
                      placeholder="Enter here"
                      style={{
                        border: "none",
                        borderBottom: "2px solid #007BFF",
                        outline: "none",
                        width: "100%",
                        padding: "6px 0",
                        color: "#000",
                      }}
                      value={productValue || ""}
                      onChange={(e) => setProductValue(e.target.value)}
                      className="custom-input w-100"
                    />{" "}
                    <span className="error-txt fs-12 fw-500 ">
                      {errorMsg.name}
                    </span>
                  </div>
                  <div className="col ps-5">
                    {image ? (
                      <>
                        <div
                          style={{
                            position: "relative",
                            width: "100px",
                            height: "100px",
                          }}
                          className="cursor-pointer"
                        >
                          <div
                            onClick={handleInputFile}
                            onDrop={handleDrop}
                            onDragOver={(e) => e.preventDefault()}
                            onDragEnter={() => setDragging(true)}
                            onDragLeave={() => setDragging(false)}
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                              objectFit: "cover",
                              overflow: "hidden",
                            }}
                          >
                            <img
                              src={image}
                              className="rounded-circle"
                              alt="Uploaded Vehicle"
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "cover",
                                borderRadius: "50%",
                              }}
                            />
                          </div>
                          <button
                            onClick={(e) => {
                              setImage(null);
                            }}
                            style={{
                              position: "absolute",
                              top: "-5px",
                              right: "-5px",
                              background: "white",
                              border: "none",
                              borderRadius: "50%",
                              cursor: "pointer",
                              padding: "4px",
                            }}
                          >
                            <X size={16} color="#ff0000" />
                          </button>
                        </div>
                      </>
                    ) : imageUrl !== "" ? (
                      <>
                        <div
                          style={{
                            position: "relative",
                            width: "100px",
                            height: "100px",
                          }}
                        >
                          <div
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                              objectFit: "cover",
                              overflow: "hidden",
                            }}
                          >
                            <img
                              src={imageUrl}
                              className="rounded-circle"
                              alt="Uploaded Vehicle"
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "cover",
                                borderRadius: "50%",
                              }}
                            />
                          </div>
                          <button
                            onClick={() => {
                              setImageUrl("");

                              setImageRemoved(true);
                              console.log("Changes.s.", imageRemoved);
                            }}
                            style={{
                              position: "absolute",
                              top: "-5px",
                              right: "-5px",
                              background: "white",
                              border: "none",
                              borderRadius: "50%",
                              cursor: "pointer",
                              padding: "4px",
                            }}
                          >
                            <X size={16} color="#ff0000" />
                          </button>
                        </div>
                      </>
                    ) : (
                      <div
                        className="d-flex cursor-pointer align-items-center justify-content-center rounded-4 p-4"
                        style={{
                          width: "116px",
                          height: "116px",
                          background: "#F6F5FF",
                        }}
                        onClick={handleInputFile}
                        onDrop={handleDrop}
                        onDragOver={(e) => e.preventDefault()}
                        onDragEnter={() => setDragging(true)}
                        onDragLeave={() => setDragging(false)}
                      >
                        <img src={uploadImage} alt="add" />
                      </div>
                    )}
                    <input
                      type="file"
                      accept="image/*"
                      ref={fileInputRef}
                      className="d-none"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
                <p className="fs-14 fw-600 mt-3 mb-2">Basic Information</p>
                <div className="align-items-center row">
                  <div className="col-xl-1 pe-0">
                    <label className="form-label d-flex justify-content-xl-end fw-500 fs-13 my-2 me-2">
                      Code<span className="error-text">*</span>
                    </label>
                  </div>
                  <div className="col-xl-4">
                    <input
                      type="text"
                      className="form-control rounded-3 vendor-form-input"
                      placeholder="Enter here"
                      value={codeValue || ""}
                      onChange={(e) => setCodeValue(e.target.value)}
                    />
                    <span className="error-txt fs-12 fw-500 ">
                      {errorMsg.code}
                    </span>
                  </div>

                  <div className="col-xl-2 pe-0">
                    <label className="form-label d-flex justify-content-xl-end fw-500 fs-13 my-2 me-2">
                      Origin
                    </label>
                  </div>
                  <div className="col-xl-4">
                    <CommonDropdown
                      apiUrl={`${adminUrl}get_country?term=`}
                      placeholder="Select"
                      className="w-100"
                      style={{ width: "100%" }}
                      value={orginOption}
                      onSelect={(item) => {
                        setOrginOption(item);
                      }}
                    />{" "}
                    <span className="error-txt fs-12 fw-500 ">
                      {errorMsg.origin}
                    </span>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xl-1 pe-0">
                    <label className="form-label d-flex justify-content-xl-end fw-500 fs-13 my-2 mt-xl-4 me-2">
                      UOM<span className="error-text">*</span>
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <CommonDropdown
                      apiUrl={`${apiUrl}get_uom?term=`}
                      placeholder="Select"
                      className="w-100"
                      style={{ width: "100%" }}
                      value={uomOption}
                      onSelect={(item) => {
                        setUomOption(item);
                      }}
                    />{" "}
                    <span className="error-txt fs-12 fw-500 ">
                      {errorMsg.uom}
                    </span>
                  </div>

                  <div className="col-xl-2 pe-0">
                    <label className="form-label d-flex justify-content-xl-end fw-500 fs-13 mt-xl-4 my-2 me-2">
                      Status
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <CommonStaticDropdown
                      items={[
                        {
                          value: true,
                          label: "Active",
                        },
                        { value: false, label: "In-Active" },
                      ]}
                      placeholder="Select"
                      value={statusOption}
                      enableSearch={false}
                      onSelect={(item) => {
                        setStatusOption(item);
                      }}
                    />{" "}
                    <span className="error-txt fs-12 fw-500 ">
                      {errorMsg.status}
                    </span>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xl-1 pe-0">
                    <label className="form-label d-flex justify-content-xl-end fw-500 fs-11 my-2 mt-xl-4 me-2 text-nowrap">
                      Group
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <CommonDropdown
                      apiUrl={`${apiUrl}get_product_group?term=`}
                      placeholder="Select"
                      className="w-100"
                      style={{ width: "100%" }}
                      value={partFamilyOption}
                      onSelect={(item) => {
                        setPartFamilyOption(item);
                      }}
                    />{" "}
                    <span className="error-txt fs-12 fw-500 ">
                      {errorMsg.product_group_id}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-3">
              <div className="bg-white rounded-4 p-3">
                <p className="fs-16 fw-600">Other Information</p>
                <div className="row">
                  <div className="col-xl-1 pe-0">
                    <label className="form-label d-flex justify-content-xl-end fw-500 fs-13 my-2 me-2">
                      Dimension
                    </label>
                  </div>
                  <div className="col-xl-1 p-xl-0 pe-xl-2">
                    <input
                      type="number"
                      className="form-control rounded-3 vendor-form-input"
                      placeholder="L"
                      value={lengthValue || ""}
                      onChange={(e) => setLengthValue(e.target.value)}
                    />
                  </div>
                  <div className="col-xl-1 p-xl-0 pe-xl-2 mt-3 mt-xl-0">
                    <input
                      type="text"
                      className="form-control rounded-3 vendor-form-input"
                      placeholder="B"
                      value={breadthValue || ""}
                      onChange={(e) => setBreadthValue(e.target.value)}
                    />
                  </div>
                  <div className="col-xl-1 px-xl-0 pe-2 mt-3 mt-xl-0">
                    <input
                      type="text"
                      className="form-control rounded-3 vendor-form-input"
                      placeholder="H"
                      value={heightValue || ""}
                      onChange={(e) => setHeightValue(e.target.value)}
                    />
                  </div>
                  <div className="col-xl-1 mt-xl-0 mt-3 mt-xl-0">
                    <Dropdown>
                      <Dropdown.Toggle
                        id="dropdown-basic"
                        className="text-black border-0 px-3 py-2"
                        style={{ backgroundColor: "#F8F8F8" }}
                      >
                        {selectedUnit?.label || ""}{" "}
                        <img src={dropDown} alt="dropdown" />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {selectUnitOption.map((option) => (
                          <Dropdown.Item
                            key={option.value}
                            onClick={() => setSelectedUnit(option)}
                          >
                            {option.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>{" "}
                  <span className="error-txt fs-12 fw-500 ">
                    {errorMsg.width}
                  </span>
                  <span className="error-txt fs-12 fw-500 ">
                    {errorMsg.length}
                  </span>
                  <span className="error-txt fs-12 fw-500 ">
                    {errorMsg.height}
                  </span>
                  <div className="row">
                    <div className="col-xl-1 pe-0">
                      <label className="form-label d-flex justify-content-xl-end fw-500 fs-13 my-2 mt-xl-4 me-2">
                        Suppliers
                      </label>
                    </div>
                    <div className="col-xl-11 mt-xl-3">
                      <AsyncSelect
                        isMulti
                        cacheOptions
                        value={selectedSupplierList}
                        loadOptions={fetchOptionsAutoSupplier}
                        onChange={(selectedOptions) => {
                          console.log("selectedOptions", selectedOptions);
                          handleAutoSupplierDropdownChange(selectedOptions);
                        }}
                        defaultOptions
                        placeholder="Search supplier..."
                        styles={multiselectCustomStyles}
                        isClearable={false}
                        menuPortalTarget={document.body}
                        menuPlacement="auto"
                      />{" "}
                      <span className="error-txt fs-12 fw-500 ">
                        {errorMsg.suppliers}
                      </span>
                    </div>
                    <div className="col-xl-1 pe-0 mt-xl-3 mt-0">
                      <label className="form-label d-flex justify-content-xl-end fw-500 fs-13 my-2 me-2">
                        Description
                      </label>
                    </div>
                    <div className="col-xl-11 mt-xl-3 mt-0">
                      <textarea
                        className="form-control rounded-3 vendor-form-input"
                        placeholder="Enter here"
                        rows={1}
                        value={descriptValue || ""}
                        onChange={(e) => setDescriptValue(e.target.value)}
                      ></textarea>
                      <span className="error-txt fs-12 fw-500 ">
                        {errorMsg.description}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
